import React, { useEffect, useState } from 'react'
import PageLayout from '../layouts/DefaultLayout'
import { discoveryPage } from '../api/content/pages'
import { Box, Text, Button } from '@deseretbook/react-ui'
import Carousel from '../components/carousel/Carousel'
import Quote from '../components/quote/Quote'
import { Link } from 'react-router-dom'
import LoadingIndicator from '../components/media/loadingIndicator/LoadingIndicator'
import { useDiscover } from './DiscoverContext'
import ErrorComponent from '../components/ErrorComponent'
import ContinueMedia from '../components/continueMedia/ContinueMedia'

const Banner = ({ section }) => {
  const imageUrl = section.tabletImageUrl || section.mobileImageUrl
  return (
    <Box
      className="banner"
      alignItems="center"
      justifyContent="center"
      style={{ margin: '40px 24px' }}
    >
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.deseretbook.com/bookshelf-plus-landing-page/bookshelf-plus-landing-page.html"
      >
        <img
          src={imageUrl}
          alt={(section.mediaData && section.mediaData.title) || 'Banner'}
          style={{ borderRadius: '20px', width: '100%', height: 'auto' }}
        />
      </a>
    </Box>
  )
}

const CarouselContainer = ({ section }) => {
  // Limit dynamic items to 20 MAX
  const itemsToShow = ((section && section.dynamicItems) || []).slice(0, 20)
  const showViewAll = ((section && section.dynamicItems) || []).length > 20
  return (
    <Box className="carousel" style={{ margin: '40px 0' }}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        style={{ margin: '0 24px 12px 24px' }}
      >
        <Text
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '20px',
            fontWeight: 600,
            marginBottom: '12px',
            display: 'inline-block',
          }}
        >
          {section.header}
        </Text>
        {showViewAll && (
          <Button
            as={Link}
            to={`/discover/${section.id}`}
            style={{
              borderRadius: '20px',
              backgroundColor: '#B6BFBF26',
              border: 'none',
              fontWeight: 700,
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif',
              padding: '12px 20px',
            }}
          >
            View All
          </Button>
        )}
      </Box>
      <Box className="carousel-track" isFullwidth alignItems="flex-end" justifyContent="center">
        <Carousel items={itemsToShow} />
      </Box>
    </Box>
  )
}

const QuoteContainer = ({ section }) => (
  <Box className="featured-section">
    <Box
      className="featured-items"
      isFullwidth
      alignItems="flex-end"
      justifyContent="space-between"
      style={{ margin: '40px 0' }}
    >
      <Quote quote={section} />
    </Box>
  </Box>
)

/**
 * Landing page for Media items
 *
 * @param {object} props - component props
 * @returns {function} Component
 */
const DiscoverPage = () => {
  const { discoverData, setDiscoverData, isLoading, setIsLoading } = useDiscover()
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)
        const response = await discoveryPage()
        setDiscoverData(response.page)
      } catch (error) {
        console.log(JSON.stringify(error))
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    if (!discoverData) {
      fetchData()
    }
    // eslint-disable-next-line
  }, [setIsLoading])

  useEffect(() => {
    localStorage.setItem('breadcrumb', 'discover')
  }, [])

  if (error) {
    return (
      <PageLayout>
        <ErrorComponent error={error} />
      </PageLayout>
    )
  }

  return (
    <PageLayout id="DiscoverPageContainer">
      {isLoading ? (
        <LoadingIndicator isRelative />
      ) : (
        <Box style={{ width: '98%', margin: '0 auto' }}>
          {((discoverData && discoverData.elements) || []).map((section) => {
            switch (section.elementType) {
              case 'banner':
                return <Banner key={section.id} section={section} />
              case 'continue':
                return <ContinueMedia key={section.id} />
              case 'daily_quote':
                return <QuoteContainer key={section.id} section={section} />
              default:
                return <CarouselContainer key={section.id} section={section} />
            }
          })}
        </Box>
      )}
    </PageLayout>
  )
}

export default DiscoverPage
